const leftMenu = () => {
    const scrollToActiveMenu = () => {
        const $parent = $(".left-menu-wrap .menu-list");
        if ($(window).width() > 1024) return;
        if (!$parent.length) return;
        const $activeItem = $parent.find("li.active");
        if(!$activeItem.length) return;
        const left = $activeItem.position().left;
        $parent.animate({ scrollLeft: left }, 300)
    }

    scrollToActiveMenu();
}

module.exports = leftMenu
